import { inspectedItemSelector } from "@redux/inspect/selector";
import isEqual from "@util/isEqual";
import { hasAttr } from "@util/Obj";
import { useSelector } from "react-redux";


export const useInspectedAttr = (attributes = 'all') => {
    const item = useSelector(inspectedItemSelector, isEqual)
    const component = item?.breakPoint ? {...item, type: 'screen'} : item;
    
    if(attributes != 'all' && Array.isArray(attributes)){
        let selected = {};
        attributes.forEach(attribute => {
            if(hasAttr(component, attribute))
                selected = {
                    ...selected,
                    [attribute]: component[attribute]
                };
        });
        return selected;
    }
    return component;
}

